import { render, staticRenderFns } from "./RsaPazientePersonaRiferimentoPage.vue?vue&type=template&id=d2af72bc"
import script from "./RsaPazientePersonaRiferimentoPage.vue?vue&type=script&lang=js"
export * from "./RsaPazientePersonaRiferimentoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports